import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';

import EmbeddedMediumLinkViewModelT from '@/ViewModels/Controls/EmbeddedMediumLinkViewModel';
import EmbeddedMediumLinkT from '@/Controls/EmbeddedMediumLink';

export default class EmbeddedMediumLinkFactory extends ControlFactory {

    private controlHtmlElement: JQuery;
    private technicalNameRootProperty = '';
    private technicalNameFilename = '';

    public constructor(private params: any) {
        super(params);
    }

    public getControl(): JQuery {
        if (this.controlHtmlElement != null) {
            return this.controlHtmlElement;
        }

        let EmbeddedMediumLinkViewModel = ComponentManager.getViewModel<typeof EmbeddedMediumLinkViewModelT>('EmbeddedMediumLinkViewModel');
        let EmbeddedMediumLink = ComponentManager.getControl<typeof EmbeddedMediumLinkT>('EmbeddedMediumLink');

        this.validateTechName();

        this.viewModel = new EmbeddedMediumLinkViewModel({
            pdoId: this.context.genericObject.pdoId,
            lockGroupID: this.context.detailViewContextDTO.lockGroupID,
            attributeName: this.technicalNameRootProperty,
            caption: this.context.genericObject.getObservable(this.technicalNameFilename)
        });
        this.control = new EmbeddedMediumLink(this.viewModel as EmbeddedMediumLinkViewModelT);

        let tuple = this.control.getTuple();
        this.controlHtmlElement = tuple.control;

        return this.controlHtmlElement;
    }

    private validateTechName() {
        this.technicalNameRootProperty = this.detailViewItem.name;

        if (this.detailViewItem.name.substring(this.detailViewItem.name.length - 6) === '.Value') {
            this.technicalNameRootProperty = this.detailViewItem.name.substring(0, this.detailViewItem.name.length - 6);
        }

        this.technicalNameFilename = this.technicalNameRootProperty + '.Filename';

    }
}

ComponentManager.setFactory('EmbeddedMediumLink', EmbeddedMediumLinkFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');